import { Box, Button } from "@chakra-ui/react";
import React, { memo, useCallback } from "react";
import colors from "app/colors";
import { AdminUndoTrashIcon, TrashOutlineIcon } from "modules/icons";
import { useOverlay } from "modules/providers/overlay-provider";
import { MODAL_TYPE } from "modules/providers/overlay-provider/overlay-provider";
import { InternalAdminUserFragment } from "gql/graphql";

interface IProps {
  user: InternalAdminUserFragment;
}

const InternalAdminEditUserActive = ({ user }: IProps) => {
  const { openModal } = useOverlay();

  const onDeactivateUserClicked = useCallback(() => {
    openModal({
      type: MODAL_TYPE.INTERNAL_ADMIN_DEACTIVATE_USER,
      id: user.id,
    });
  }, [openModal, user]);

  const onReactivateUserClicked = useCallback(() => {
    openModal({
      type: MODAL_TYPE.INTERNAL_ADMIN_REACTIVATE_USER,
      id: user.id,
    });
  }, [openModal, user.id]);

  if (user.active) {
    return (
      <Box w="full" borderTopWidth={1} borderColor={colors.grayMain} py={2}>
        <Button
          p={0}
          leftIcon={<TrashOutlineIcon boxSize={4} fill={colors.gray40} />}
          color={colors.gray40}
          fontSize={12}
          variant="ghost"
          onClick={onDeactivateUserClicked}
          size="xs"
        >
          Deactivate User
        </Button>
      </Box>
    );
  }

  return (
    <Box w="full" borderTopWidth={1} borderColor={colors.grayMain} py={2}>
      <Button
        p={0}
        leftIcon={<AdminUndoTrashIcon boxSize={4} fill={colors.gray40} />}
        color={colors.gray40}
        fontSize={12}
        variant="ghost"
        onClick={onReactivateUserClicked}
        size="xs"
      >
        Reactivate User
      </Button>
    </Box>
  );
};

export default memo(InternalAdminEditUserActive);
